module.exports = __webpack_public_path__ + "img/logo.28d4b06e.png";